export const languageMethods = {
  namespaced: true,
  methods: {
    setCurrentLanguage (lang) {
      this.$store.commit('setLang', lang)
    },
  },
}
